import Vue from 'vue';
import Router from 'vue-router';

import Layout from '@/components/Layout/Layout';

// Pages
import Optix from '@/views/Optix';
import Westnet from '@/views/Westnet';
import Bitway from '@/views/Bitway';
import RegisterView from '@/views/RegisterView';
import Tecnicos from '@/views/Tecnicos';
import Totales from '@/views/Totales';
import HomeView from '@/views/HomeView';
import Login from "@/views/LoginView";
import Equipos from "@/views/Equipos";
import EquiposTecnicos from "@/views/EquiposTecnicos";
import EquipoStore from "../store/index";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
    path: '/',
    redirect: 'login',
    name: 'Layout',
    component: Layout,
    children: [
      {
        path: 'optix',
        name: 'Optix',
        component: Optix,
        meta: {
          requiresAuth: true
        },
      },
      {
        path: 'westnet',
        name: 'Westnet',
        component: Westnet,
        meta: {
          requiresAuth: true
        },
      },
      {
        path: 'bitway',
        name: 'Bitway',
        component: Bitway,
        meta: {
          requiresAuth: true
        },
      },
      {
        path: 'registerView',
        name: 'RegisterView',
        component: RegisterView,
        meta: {
          requiresAuth: true
        },
      },
      {
        path: 'tecnicos',
        name: 'Tecnicos',
        component: Tecnicos,
        meta: {
          requiresAuth: true
        },
      },
      {
        path: 'totales',
        name: 'Totales',
        component: Totales,
        meta: {
          requiresAuth: true
        },
      },
      {
        path: 'homeVIew',
        name: 'HomeView',
        component: HomeView,
        meta: {
          requiresAuth: true
        },
      },
      {
        path: 'equiposVIew',
        name: 'EquiposView',
        component: Equipos,
        meta: {
          requiresAuth: true
        },
      },
      {
        path: 'equiposTecnicos',
        name: 'EquiposTecnicos',
        component: EquiposTecnicos,
        meta: {
          requiresAuth: true
        },
      }
      // {
      //   path: 'tables',
      //   name: 'Tables',
      //   component: Tables
      // },
      // {
      //   path: 'notifications',
      //   name: 'Notifications',
      //   component: Notifications
      // },
      // {
      //   path: 'icons',
      //   name: 'Icons',
      //   component: Icons
      // },
      // {
      //   path: 'charts',
      //   name: 'Charts',
      //   component: Charts
      // },
      // {
      //   path: 'maps',
      //   name: 'Maps',
      //   component: Maps
      // },
    ],
  },
    // {
    //   path: '*',
    //   name: 'Error',
    //   component: Error
    // }
  ],
  beforeEach:(to, from, next) => {
    if (to.meta.requiresAuth)  {
      if (EquipoStore.data.auth) {
        console.log('ruta autenticad')
        next();
        
      } else {
        next({ name: "Login" });
      }
    } else {
      next();
    }
  }
});
